import { handlePrintAuctionsListItem } from "@/lib/auctions";
import classNames from "classnames";
import Image from "next/image";
import React, { useContext } from "react";
import { AuctionItemListContext } from "../AuctionItem/AuctionListItems";
import toast from "react-hot-toast";

interface LayoutTypeProps {
  layoutType: "grid" | "list" | "print";
  setLayoutType: (type: "grid" | "list" | "print") => void;
}

export const LayoutType: React.FC<LayoutTypeProps> = ({
  layoutType,
  setLayoutType,
}) => {
  const context = useContext(AuctionItemListContext) || {};
  const auctionItems = context.auctionItems || [];
  const currentItem = auctionItems[0];

  return (
    <div className="flex flex-row items-center justify-center gap-2">
      <div
        className={classNames(
          "cursor-pointer py-2 px-3 rounded-md hover:bg-aliceblue",
          {
            "opacity-100 bg-aliceblue": layoutType === "grid",
            "opacity-50": layoutType !== "grid",
          }
        )}
        onClick={() => setLayoutType("grid")}
      >
        <Image
          className="relative w-8 h-8"
          alt="Grid layout"
          src="/icons/layout-2.svg"
          width={32}
          height={32}
        />
      </div>

      <div className="h-5 border-l border-gray-300"></div>

      <div
        className={classNames(
          "cursor-pointer py-2 px-3 rounded-md hover:bg-aliceblue",
          {
            "opacity-100 bg-aliceblue": layoutType === "list",
            "opacity-50": layoutType !== "list",
          }
        )}
        onClick={() => setLayoutType("list")}
      >
        <Image
          className="relative w-8 h-8"
          alt="List layout"
          src="/icons/layout-1.svg"
          width={32}
          height={32}
        />
      </div>

      <div className="h-5 border-l border-gray-300"></div>

      <div
        className={classNames(
          "cursor-pointer py-2 px-3 rounded-md hover:bg-aliceblue",
          {
            "opacity-100 bg-aliceblue": layoutType === "print",
            "opacity-50": layoutType !== "print",
          }
        )}
        onClick={async () => {
          if (currentItem?.itemPartId) {
            const toastId = toast.loading("Skriver ut...", {
              position: "top-right",
            });
            try {
              await handlePrintAuctionsListItem(currentItem.itemPartId);
            } finally {
              toast.dismiss(toastId);
            }
          }
        }}
      >
        <Image
          className="relative w-8 h-8"
          alt="Print layout"
          src="/icons/printer.svg"
          width={32}
          height={32}
        />
      </div>
    </div>
  );
};
